import { render } from "./AccountsAccountView.vue?vue&type=template&id=7fbc2196"
import script from "./AccountsAccountView.vue?vue&type=script&lang=js"
export * from "./AccountsAccountView.vue?vue&type=script&lang=js"
script.render = render

export default script